window.__TUPLATA_DEPLOY_CONFIG__ = { apiBase: import.meta.env.VITE_API_BASE || "" };